<script setup>
  import GererForm from '@/components/GererForm.vue'
</script>

<template>
  <div class="home">

    <h1>Espaces persos</h1>
    <button class="back" @click="goBack"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
    </svg>Retour</button>
    <div class="container">
      
      <div class="row">
        <GererForm/>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  data() {
      return {
        designation: null,
        designation2: null,
        designation3: null,
        codeArticle: null,
        loggedInRole: null,
      };
  },
  created() {
        this.designation = this.$route.params.designation;
        this.designation2 = this.$route.params.designation2;
        this.designation3 = this.$route.params.designation3;
        this.codeArticle = this.$route.params.codeArticle;

        
    },
  methods: {
    goBack() {
      const queryParams = {
        page: this.currentPage,
        searchTerm: this.searchTerm,
        selectedMag: this.selectedMag,
        selectedFourn: this.selectedFourn,
        showOnlyAvailable: this.showOnlyAvailable
      };
      this.$router.go(-1);
      this.$router.push({ query: queryParams });
    }
  }
}
</script>

<style>

 button.back {
  display: inherit;
  margin: auto;
  margin-bottom: 20px!important;
  display: flex;
  align-items: center;
 }

 @media screen and (max-width:992px) {
  .back {
    margin-top: 30px!important;
  }
}

 button.back svg {
  height: 24px;
  width: 24px;
  margin-right: 6px;
 }
</style>
